import { ZZMColor } from '@zazume/zzm-base';

import { UtilityStatesType } from './types';

export const UTILITY_STATE_COLORS: Record<UtilityStatesType, ZZMColor | undefined> = {
  pending: undefined,
  completed: 'Green',
  inProgress: 'Primary',
  processed: 'Mostard',
  incident: 'Red',
  rejected: 'Gray400',
  dismissed: 'Gray300',
  notRequired: 'Gray300'
};

export const UTILITY_STATE_ALTERNATE_COLORS: Record<UtilityStatesType, ZZMColor | undefined> = {
  pending: undefined,
  completed: 'Green',
  inProgress: 'Cian',
  processed: 'Mostard',
  incident: 'Red',
  rejected: 'Orange',
  dismissed: undefined,
  notRequired: undefined
};
